module.exports = __webpack_public_path__ + "static/media/Client to clinical team ratio.3575506b.svg";